import { TikTokPaymentData } from '../../entities';
import { AppnebulaTikTokService, TikTokService } from '../../interfaces';

export class AppnebulaHttpTikTokService implements AppnebulaTikTokService {
  constructor(private readonly tikTokService: TikTokService) {}

  onFunnelOpened() {
    return this.tikTokService.track('ViewContent');
  }

  addBirthdate() {
    return this.tikTokService.track('SubmitForm');
  }

  addEmail(email: string, userId: string) {
    return this.tikTokService.track('CompleteRegistration', { email, event_id: userId });
  }

  addToCard({ email, orderId, productId, price, currency }: TikTokPaymentData) {
    return this.tikTokService.track('AddToCart', {
      email,
      value: price,
      event_id: orderId,
      currency,
      product_id: productId,
    });
  }

  initiateCheckout({ email, orderId, productId, price, currency }: TikTokPaymentData) {
    return this.tikTokService.track('InitiateCheckout', {
      email,
      value: price,
      event_id: orderId,
      currency,
      product_id: productId,
    });
  }

  paymentSuccess({ email, orderId, productId, price, currency, ltvPredict }: TikTokPaymentData) {
    return this.tikTokService.track('CompletePayment', {
      email,
      price,
      value: ltvPredict,
      event_id: orderId,
      currency,
      product_id: productId,
    });
  }
}
